import colors from "../../../config/colors";
import { ConfigComps } from "../../../config/ConfigCOMP";
import { Button, Card, Grid, IconButton, TextField, Theme, useTheme } from "@mui/material";
import { TextWithLink } from "../../../components/text_with_link_text/TextWithLink";
import EditText from "../../../components/editText/EditText";
import { styled as styledMUI } from "@mui/material/styles";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import links from "../../../config/links";
import { useState } from "react";
import { isVisibilityProgressBar } from "../../../store/ProgressbarInRootSlice";
import { RequestHandler } from "../../../api/API";
import { EnumServerSelected, HandlerLangUrl, urlsListAzmoon, urlsListPdfGenHomzhans } from "../../../api/UrlsList";
import { enumTypeOfAlert } from "../../../components/MUIConfig/alert_popup/interfaceAlertPopup";
import { ShowAlert } from "../../../store/AlertStateModeSlice";
import { useDispatch } from "react-redux";
import { SetTokenAndRefreshToken } from "../../../store/profileStateSlice";
import { InterfaceDataOfResponseServer, InterfaceResponceCreatePdfInDB, InterfaceResponseServer, InterfaceResultOfDataOfResponseServer, InterfaceTest, InterfaceTestsOfResultOfDataOfResponseServer } from "./interfaceTest";
import { GridFromMUI } from "../../../components/MUIConfig/GridFromMUI";
import { DownloadDoneRounded, FileDownloadRounded, HomeRounded, PictureAsPdfRounded } from "@mui/icons-material";
import { blob } from "stream/consumers";
import TitleOfTableInResult from "../../../units/tests";


const DivAllTextContainer = styledMUI(Card)(({ theme }) => ({
    display: "flex",
    color: "black",
    paddingTop: "calc(48px + 2vh)",
    background: "rgba(254,254,254,0.6)",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "start",
    zIndex: 100,
    maxHeight: "100%",

    // position: "absolute",
    // top: "2%",
    minWidth: "90vw",
    padding: "24px",

}));
const CardTestContainer = styledMUI(Card)(({ theme }) => ({
    display: "flex",
    width: "100%",
    color: "black",
    background: "rgba(254,254,254,0.6)",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "start",

}));

const CardTitleContainer = styledMUI(Card)(({ theme }) => ({
    display: "flex",
    width: "100%",
    color: "black",
    background: "rgba(254,254,254,0.9)",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "start",
    border: "1px solid",

}));
const ImageBackGround = styledMUI("img")(({ theme }) => ({
    objectFit: "cover",
    position: "absolute",
    top: 0,
    right: theme.direction == "rtl" ? 0 : undefined,
    left: theme.direction == "rtl" ? undefined : 0,
    zIndex: 0,
    maxHeight: "100vh",
    minWidth: "50%",

    alignItems: "center",
    width: "100%",
    height: "100%",

}));

const PTextTitle1 = styledMUI("h6")(({ theme }) => ({
    color: colors.editText.darkTitleColor,
    whiteSpace: "nowrap",


}));
const PTextTitleInCell = styledMUI("h6")(({ theme }) => ({
    color: colors.editText.darkTitleColor,
    margin: "1vh 1vw",
    [theme.breakpoints.down("md")]: {
        fontSize: "1rem"
    },
    [theme.breakpoints.down("sm")]: {
        fontSize: "0.8rem"
    }

}));
const PTextValue1 = styledMUI("p")(({ theme }) => ({
    color: colors.editText.darkTitleColor,
    whiteSpace: "pre-line"
}));
const DivGroup1 = styledMUI("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    gap: "calc(1vw + 8px)",


}));

const DivCell = styledMUI("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "calc(1vw + 8px)",
    border: "1px solid",
    height: "100%",
    paddingLeft: "calc(24px + 1vw)",
    paddingRight: "calc(24px + 1vw)"


}));



function Test(params: InterfaceTest) {
    const [getIsShowDownloadAllTestInDialog, setIsShowDownloadAllTestInDialog] = useState<boolean>(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let response = useLocation().state;
    window.history.replaceState({}, document.title)
    const mTheme = useTheme();
    var confComps = ConfigComps();
    const removeASpecificCharacter = (sentence: string) => {
        let arraySplite = sentence.split("\\")
        return arraySplite[arraySplite.length - 1]

        return sentence.replaceAll("\\", " ")

    }
    const getPdfFromServer = async (id: number) => {
        // dispatch(isVisibilityProgressBar(true));
        const strQuery = `${id}/`



        const link = document.createElement('a');
        link.href = HandlerLangUrl(urlsListPdfGenHomzhans.getPDFSigned.url + strQuery, mTheme, EnumServerSelected.pdfGenHomzhans);
        link.setAttribute('download', 'test.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        dispatch(ShowAlert({ text: "دانلود فایل", typeAlert: enumTypeOfAlert.success, lastTimeSecondsUpdate: (new Date()).getSeconds() }));





    }
    const getEgeFromBithDay = (strMiladi: string) => {
        let nowYear = new Date().getFullYear();

        return (nowYear - parseInt(strMiladi.split("-")[0], 0))
    }
    const onClickPrintAllTests = async (OneUser: InterfaceDataOfResponseServer) => {
        dispatch(isVisibilityProgressBar(true));

        let dataSend = {
            FullName: OneUser.FullName,
            FName: OneUser.FName,
            LName: OneUser.LName,
            FNameEn: OneUser.FNameEn,
            LNameEn: OneUser.LNameEn,
            Airline: OneUser.Airline,
            Passport: OneUser.Passport,
            Sex: OneUser.Sex,
            BirthDate: OneUser.BirthDate,
            NationalCode: OneUser.NationalCode,
            Phone: OneUser.Phone,
            ReceptionCode: OneUser.ReceptionCode,
            ReceptionDate: OneUser.ReceptionDate,
            ResultDate: OneUser.ResultDate,
            RemainingAmount: OneUser.RemainingAmount,
            DoctorName: OneUser.DoctorName,
            DoctorCode: OneUser.DoctorCode,
            UserId: OneUser.UserId,
            UserName: OneUser.UserName,
            LabId: OneUser.LabId,
            LabName: OneUser.LabName,
            LabMobile: OneUser.LabMobile,
            Result: OneUser.Result.map((GroupTest, index, array) => {
                return (
                    {
                        Section: GroupTest.Section,
                        Tests: GroupTest.Tests.filter(test => (test.Result.toUpperCase().length > 1))
                            .map((test, index, array) => {
                                return (
                                    {
                                        Order: test.Order,
                                        Name: test.Name,
                                        Result: test.Result.replace("\r", "").replace("\n", "").replace("\\", ""),
                                        Unit: test.Unit,
                                        Method: test.Method,
                                        NormalRange: test.NormalRange,
                                        Status: test.Status,
                                        Comment: test.Comment,
                                        Comment2: test.Comment2,
                                        TestCode: test.TestCode,
                                        SampleType: test.SampleType
                                    }
                                )
                            })
                    }
                )
            })
        }
        await RequestHandler(dispatch, HandlerLangUrl(urlsListPdfGenHomzhans.postCreatePDF.url, mTheme, EnumServerSelected.pdfGenHomzhans),
            urlsListPdfGenHomzhans.postCreatePDF.method, urlsListPdfGenHomzhans.postCreatePDF.isTokenNecessary, dataSend)
            .then((response: any) => {
                console.log("response:)111");
                console.log(response);

                dispatch(isVisibilityProgressBar(false));

                let responseObj = response as InterfaceResponceCreatePdfInDB
                dispatch(ShowAlert({ text: "لطفا کمی دیگر صبر کنین", typeAlert: enumTypeOfAlert.success, lastTimeSecondsUpdate: (new Date()).getSeconds() }));
                getPdfFromServer(responseObj.data.pdf.id)




            })
            .catch((e: Error) => {
                console.log("response:(");
                console.log(e);
                dispatch(isVisibilityProgressBar(false));
                dispatch(ShowAlert({ text: confComps.screen.answerTest.login.notification.internetFailed, typeAlert: enumTypeOfAlert.error, lastTimeSecondsUpdate: (new Date()).getSeconds() }));
            });
    }




    const onClickPrintTest = async (OneTest: InterfaceResultOfDataOfResponseServer,idTest:string, dataOfAllTest: InterfaceResponseServer) => {
        dispatch(isVisibilityProgressBar(true));
        let dataSend = {

            FullName: dataOfAllTest.Data.FullName,
            FName: dataOfAllTest.Data.FName,
            LName: dataOfAllTest.Data.LName,
            FNameEn: dataOfAllTest.Data.FNameEn,
            LNameEn: dataOfAllTest.Data.LNameEn,
            Airline: dataOfAllTest.Data.Airline,
            Passport: dataOfAllTest.Data.Passport,
            Sex: dataOfAllTest.Data.Sex,
            BirthDate: dataOfAllTest.Data.BirthDate,
            NationalCode: dataOfAllTest.Data.NationalCode,
            Phone: dataOfAllTest.Data.Phone,
            ReceptionCode: dataOfAllTest.Data.ReceptionCode,
            ReceptionDate: dataOfAllTest.Data.ReceptionDate,
            ResultDate: dataOfAllTest.Data.ResultDate,
            RemainingAmount: dataOfAllTest.Data.RemainingAmount,
            DoctorName: dataOfAllTest.Data.DoctorName,
            DoctorCode: dataOfAllTest.Data.DoctorCode,
            UserId: dataOfAllTest.Data.UserId,
            UserName: dataOfAllTest.Data.UserName,
            LabId: dataOfAllTest.Data.LabId,
            LabName: dataOfAllTest.Data.LabName,
            LabMobile: dataOfAllTest.Data.LabMobile,
            Result: [
                {
                    Section: OneTest.Section,
                    Tests: 
                        OneTest.Tests.filter(test => test.RelatedTestId == idTest).map((test,index,array)=>{
                        return {
                            Order: test.Order,
                            Name: test.Name,
                            Result: test.Result,
                            Unit: test.Unit,
                            Method: test.Method,
                            NormalRange: test.NormalRange,
                            Status: test.Status,
                            Comment: test.Comment,
                            Comment2: test.Comment2,
                            TestCode: test.TestCode,
                            SampleType: test.SampleType,
                            TestId: test.TestId,
                            RelatedTestId: test.RelatedTestId
                        }
                    })
                        
                    
                }
            ],
        }
        // if (OneTest.Specimen) {
        //     dataSend.Result[0].Tests.push({ Order: 0, Name: "Specimen", Result: OneTest.Specimen, Unit: "", Method: "", NormalRange: "", Status: "", Comment: "", TestCode: "" })
        // }
        await RequestHandler(dispatch, HandlerLangUrl(urlsListPdfGenHomzhans.postCreatePDF.url, mTheme, EnumServerSelected.pdfGenHomzhans),
            urlsListPdfGenHomzhans.postCreatePDF.method, urlsListPdfGenHomzhans.postCreatePDF.isTokenNecessary, dataSend)
            .then((response: any) => {
                console.log("response:)111");
                console.log(response);

                dispatch(isVisibilityProgressBar(false));

                let responseObj = response as InterfaceResponceCreatePdfInDB
                dispatch(ShowAlert({ text: "لطفا کمی دیگر صبر کنین", typeAlert: enumTypeOfAlert.success, lastTimeSecondsUpdate: (new Date()).getSeconds() }));
                getPdfFromServer(responseObj.data.pdf.id)




            })
            .catch((e: Error) => {
                console.log("response:(");
                console.log(e);
                dispatch(isVisibilityProgressBar(false));
                dispatch(ShowAlert({ text: confComps.screen.answerTest.login.notification.internetFailed, typeAlert: enumTypeOfAlert.error, lastTimeSecondsUpdate: (new Date()).getSeconds() }));
            });
    }
    const CheckShowButtonShowDownloadAllPdf = (responseServerData: InterfaceResponseServer) => {
        let isShowDownloadAllPDF = false;
        if (responseServerData.Data.Result.length > 1) {
            isShowDownloadAllPDF = true
        }
        else {
            responseServerData.Data.Result.forEach(element => {
                if (element.Tests.filter(test => test.Result.length > 1).length > 1) {
                    isShowDownloadAllPDF = true
                }
            });
        }
    }

    try {

        let responseServer = response as InterfaceResponseServer;
        // CheckShowButtonShowDownloadAllPdf(responseServer)

        // for (let i = 0; i < responseServer.Data.Result.length; i++) {
        //     for (let j = 0; j < responseServer.Data.Result[i].Tests.length; j++) {
        //         if (responseServer.Data.Result[i].Tests[j].Name.toUpperCase() == "SPECIMEN") {
        //             if (j > 0) {
        //                 responseServer.Data.Result[i].Tests[j - 1].Specimen = responseServer.Data.Result[i].Tests[j].Result;
        //             }
        //         }
        //     }
        // }
        console.log("responseServer");
        console.log("responseServer");
        console.log(responseServer);


        return (
            <div style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                alignItems: "start",
                justifyContent: "center",
                maxHeight: "calc(100vh - 4em)",
                overflow: "scroll",
                backgroundImage: "green",
                backgroundRepeat: "no-repeat",
                position: "relative",
                background: `url(/assets/img/background.jpg)`,
            }}>
                {/* <ImageBackGround
                    src="/assets/img/background.jpg"
                    srcSet="/assets/img/background.jpg"
                    alt="not loaded"
                    loading="lazy"
                /> */}
                {/* <BackgroundGradientLeft />
            <BackgroundGradientRight /> */}


                <DivAllTextContainer>
                    <div style={{ margin: "10px calc(24px + 8vw)" }}>
                        <GridFromMUI container
                            justifyContent="start" alignItems="stretch"
                            columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 5, xl: 6 }}
                            rowSpacing={{ xs: 4, sm: 5, md: 5, lg: 5, xl: 5 }}
                            columns={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        >
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <CardTitleContainer>
                                    <div style={{ width: "100%", margin: "1vh 1vw" }}>
                                        <GridFromMUI container
                                            justifyContent="start" alignItems="stretch"
                                            columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 5, xl: 6 }}
                                            rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }}
                                            columns={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                        >
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <h6 style={{ color: colors.editText.darkTitleColor }}>جهت پیگیری و مراجعات دوباره شماره قبض و شماره موبایل خود را یادداشت کنین</h6>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <DivGroup1>
                                                    <PTextTitle1>کد پذیرش :</PTextTitle1>
                                                    <PTextValue1>{responseServer.Data.ReceptionCode}</PTextValue1>
                                                </DivGroup1>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <DivGroup1>
                                                    <PTextTitle1>موبایل :</PTextTitle1>
                                                    <PTextValue1>{responseServer.Data.Phone}</PTextValue1>
                                                </DivGroup1>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                {getIsShowDownloadAllTestInDialog ?
                                                    <div style={{ width: "100%", height: "10vh", display: "flex", flexDirection: "row", alignItems: "center", justifyItems: "center", justifyContent: "center" }}>
                                                        <Button variant="contained" startIcon={<div style={{ marginLeft: "12px", width: "1.2em", height: "1.2em", marginRight: "-12px" }}><FileDownloadRounded /></div>}
                                                            onClick={() => {

                                                                onClickPrintAllTests(responseServer.Data)

                                                            }}
                                                            style={{
                                                                background: colors.screens.login.btnAccept.background,

                                                                borderRadius: "5px"
                                                            }}
                                                        >  دانلود تمام تست ها </Button>
                                                    </div>
                                                    :
                                                    undefined
                                                }
                                            </Grid>
                                        </GridFromMUI>
                                    </div>

                                </CardTitleContainer>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>نام :</PTextTitle1>
                                    <PTextValue1>{removeASpecificCharacter(responseServer.Data.FName)}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>نام خانوادگی :</PTextTitle1>
                                    <PTextValue1>{removeASpecificCharacter(responseServer.Data.LName)}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>جنسیت :</PTextTitle1>
                                    <PTextValue1>{responseServer.Data.Sex}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>سن :</PTextTitle1>
                                    <PTextValue1>{getEgeFromBithDay(responseServer.Data.BirthDate)}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>کد ملی :</PTextTitle1>
                                    <PTextValue1>{responseServer.Data.NationalCode}</PTextValue1>
                                </DivGroup1>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>کد پذیرش :</PTextTitle1>
                                    <PTextValue1>{responseServer.Data.ReceptionCode}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>تاریخ پذیرش :</PTextTitle1>
                                    <PTextValue1>{responseServer.Data.ReceptionDate}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>تاریخ جواب :</PTextTitle1>
                                    <PTextValue1>{responseServer.Data.ResultDate}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            {/* <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                            <DivGroup1>
                                <PTextTitle1>باقی مانده :</PTextTitle1>
                                <PTextValue1>{responseServer.Data.RemainingAmount}</PTextValue1>
                            </DivGroup1>
                        </Grid> */}
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                                <DivGroup1>
                                    <PTextTitle1>دکتر :</PTextTitle1>
                                    <PTextValue1>{responseServer.Data.DoctorName}</PTextValue1>
                                </DivGroup1>
                            </Grid>
                            {/* <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                            <DivGroup1>
                                <PTextTitle1>کد دکتر :</PTextTitle1>
                                <PTextValue1>{responseServer.Data.DoctorCode}</PTextValue1>
                            </DivGroup1>
                        </Grid> */}
                            {/* <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                            <DivGroup1>
                                <PTextTitle1>کد :</PTextTitle1>
                                <PTextValue1>{responseServer.Data.UserId}</PTextValue1>
                            </DivGroup1>
                        </Grid> */}
                            {/* <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                            <DivGroup1>
                                <PTextTitle1>نام کاربری :</PTextTitle1>
                                <PTextValue1>{responseServer.Data.UserName}</PTextValue1>
                            </DivGroup1>
                        </Grid> */}




                        </GridFromMUI>
                    </div>

                    <br />
                    <div style={{ margin: "10px calc(24px + 8vw)", overflowX: "scroll", maxWidth: "99vw" }}>
                        <div style={{ minWidth: "380px" }}>
                            {(responseServer.Data.Result.length > 1 || responseServer.Data.Result[0].Tests.filter(test => test.Name.toUpperCase() != "SPECIMEN").length > 1) ?
                                <div style={{ width: "100%", height: "10vh", display: "flex", flexDirection: "row", alignItems: "center", justifyItems: "center", justifyContent: "center" }}>
                                    {/* <Button variant="contained" startIcon={<div style={{ marginLeft: "12px", width: "1.2em", height: "1.2em", marginRight: "-12px" }}><FileDownloadRounded /></div>}
                                        onClick={() => {
                                            // onClickPrintTest(test, result.Section, responseServer)
                                            onClickPrintAllTests(responseServer)
                                        }}
                                        style={{
                                            background: colors.screens.login.btnAccept.background,

                                            borderRadius: "5px"
                                        }}
                                    >  PDF دانلود یکپارچه </Button> */}
                                </div>
                                : undefined}
                            {responseServer.Data.Result.map((result, index, array) => {
                                return (

                                    <GridFromMUI container
                                        justifyContent="left" alignItems="stretch"
                                        style={{ direction: "ltr" }}
                                        // columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 5, xl: 6 }}
                                        // rowSpacing={{ xs: 4, sm: 5, md: 5, lg: 5, xl: 5 }}
                                        columns={{ xs: 1 }}
                                    >
                                        {result.Tests.filter(test => test.TestId == test.RelatedTestId)
                                            // .filter(test => test.Result.toUpperCase().length > 1)
                                            .map((test, index, array) => {
                                                return (
                                                    <Grid item xs={1}>
                                                        <CardTestContainer>

                                                            <GridFromMUI container
                                                                justifyContent="left" alignItems="stretch"
                                                                columns={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}

                                                            >
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <DivCell>
                                                                        <PTextTitleInCell>{result.Section}</PTextTitleInCell>
                                                                    </DivCell>
                                                                </Grid>
                                                                <Grid item xs={2}>
                                                                    <DivCell>
                                                                        <PTextTitleInCell > Test </PTextTitleInCell>
                                                                    </DivCell>
                                                                </Grid>
                                                                <Grid item xs={10}>
                                                                    <DivCell>
                                                                        <PTextValue1>{test.Name}</PTextValue1>
                                                                    </DivCell>
                                                                </Grid>

                                                                <Grid item xs={2}>
                                                                    <DivCell>
                                                                        <PTextTitleInCell > Method</PTextTitleInCell>
                                                                    </DivCell>
                                                                </Grid>
                                                                <Grid item xs={10}>
                                                                    <DivCell>
                                                                        <PTextValue1>{test.Method}</PTextValue1>
                                                                    </DivCell>
                                                                </Grid>
                                                                {test.NormalRange.length > 2 ?
                                                                    [
                                                                        <Grid item xs={2}>
                                                                            <DivCell>
                                                                                <PTextTitleInCell >Normal Range</PTextTitleInCell>
                                                                            </DivCell>
                                                                        </Grid>,
                                                                        <Grid item xs={10}>
                                                                            <DivCell>
                                                                                <PTextValue1>{test.NormalRange}</PTextValue1>
                                                                            </DivCell>
                                                                        </Grid>
                                                                    ]
                                                                    : undefined}

                                                                {test.SampleType.length > 2 ?
                                                                    [<Grid item xs={2}>
                                                                        <DivCell>
                                                                            <PTextTitleInCell > Sample Type</PTextTitleInCell>
                                                                        </DivCell>
                                                                    </Grid>,
                                                                    <Grid item xs={10}>
                                                                        <DivCell>
                                                                            <PTextValue1>{test.SampleType}</PTextValue1>
                                                                        </DivCell>
                                                                    </Grid>
                                                                    ] :
                                                                    undefined
                                                                }
                                                                <Grid item xs={2}>
                                                                    <DivCell>
                                                                        <PTextTitleInCell >result</PTextTitleInCell>
                                                                    </DivCell>
                                                                </Grid>
                                                                <Grid item xs={10}>
                                                                    <DivCell>
                                                                        <PTextValue1>{test.Result}</PTextValue1>
                                                                    </DivCell>
                                                                </Grid>
                                                                {result.Tests.filter(sub_test => sub_test.TestId != sub_test.RelatedTestId)
                                                                    .filter(sub_test => sub_test.RelatedTestId == test.TestId)
                                                                    // .filter(test => test.Result.toUpperCase().length > 1)
                                                                    .flatMap((sub_test, index, array) => {
                                                                        return[
                                                                            <Grid item xs={2}>
                                                                                <DivCell>
                                                                                    <PTextTitleInCell > {sub_test.Name}</PTextTitleInCell>
                                                                                </DivCell>
                                                                            </Grid>,
                                                                            <Grid item xs={10}>
                                                                                <DivCell>
                                                                                    <PTextValue1>{sub_test.Result}</PTextValue1>
                                                                                </DivCell>
                                                                            </Grid>
                                                                        ]
                                                                    })

                                                                }
                                                                {/* {test.Result.split("/").flatMap((res, indexRES, array) => {
                                                                    return [
                                                                        <Grid item xs={2}>
                                                                            <DivCell>
                                                                                <PTextTitleInCell > {`${(TitleOfTableInResult as any)[Object.keys(TitleOfTableInResult).indexOf(result.Section.toLowerCase().replace(" ", "")) != -1 ? result.Section.toLowerCase().replace(" ", "") : "any"][indexRES % 4]}`}</PTextTitleInCell>
                                                                            </DivCell>
                                                                        </Grid>,
                                                                        <Grid item xs={10}>
                                                                            <DivCell>
                                                                                <PTextValue1>{res}</PTextValue1>
                                                                            </DivCell>
                                                                        </Grid>
                                                                    ]
                                                                })
                                                                } */}


                                                                {
                                                                    test.Comment.length > 1 ?
                                                                        <Grid item xs={2}>
                                                                            <DivCell>
                                                                                <PTextTitleInCell > Comment</PTextTitleInCell>
                                                                            </DivCell>
                                                                        </Grid>
                                                                        : undefined
                                                                }
                                                                {
                                                                    test.Comment.length > 1 ?
                                                                        <Grid item xs={10}>
                                                                            <DivCell>
                                                                                <PTextValue1>{test.Comment}</PTextValue1>
                                                                            </DivCell>
                                                                        </Grid>
                                                                        :
                                                                        undefined
                                                                }
                                                                < Grid item xs={12} >
                                                                    <div style={{ width: "100%", height: "10vh", display: "flex", flexDirection: "row", alignItems: "center", justifyItems: "center", justifyContent: "center" }}>
                                                                        <Button variant="contained" startIcon={<div style={{ marginLeft: "12px", width: "1.2em", height: "1.2em", marginRight: "-12px" }}><FileDownloadRounded /></div>}
                                                                            onClick={() => {
                                                                                onClickPrintTest(result,test.RelatedTestId, responseServer)
                                                                            }}
                                                                            style={{
                                                                                background: colors.screens.login.btnAccept.background,

                                                                                borderRadius: "5px"
                                                                            }}
                                                                        >  دانلود  pdf </Button>
                                                                    </div>
                                                                </Grid>



                                                                {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                                                <DivGroup1>
                                                                    <PTextTitle1>  واحد :</PTextTitle1>
                                                                    <PTextValue1>{test.Unit}</PTextValue1>
                                                                </DivGroup1>
                                                            </Grid> */}

                                                                {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                                                <DivGroup1>
                                                                    <PTextTitle1> وضعیت :</PTextTitle1>
                                                                    <PTextValue1>{test.Status}</PTextValue1>
                                                                </DivGroup1>
                                                            </Grid> */}
                                                                {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                                                <DivGroup1>
                                                                    <PTextTitle1> کد تست:</PTextTitle1>
                                                                    <PTextValue1>{test.TestCode}</PTextValue1>
                                                                </DivGroup1>
                                                            </Grid> */}





                                                            </GridFromMUI>
                                                        </CardTestContainer>

                                                    </Grid>
                                                )
                                            })}

                                    </GridFromMUI>
                                )
                            })
                            }
                        </div>
                    </div>

                </DivAllTextContainer >
            </div >
        )
    }
    catch (e: any) {
        navigate(links.answerTest.login);
        return (
            <div></div>
        )
    }
}

export default Test;
